import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import profileIcons from './profilesIconMap';
import { withStyles } from '../theme';
import { isolateMixin, middleMixin } from '../utils/mixins';

var chooseProfileSize = function chooseProfileSize(size) {
  return size >= 75 ? [30, 20, 2] : size >= 45 ? [20, 15, 1] : size >= 30 ? [15, 12, 1] : [11, 10, 1];
};

var styles = function styles(theme) {
  return {
    avatar: {
      extend: isolateMixin,
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'middle',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      boxShadow: theme.avatar.boxShadow
    },
    circle: {
      borderRadius: '50%',
      '& $profile': {
        transform: 'translate(2%, 2%)'
      }
    },
    rounded: {
      borderRadius: '7%'
    },
    profile: {
      extend: middleMixin,
      position: 'absolute',
      right: 0,
      bottom: 0,
      transform: 'translate(25%, 25%)',
      borderRadius: '100%',
      fontSize: 0,
      textAlign: 'center'
    }
  };
};

var _ref = /*#__PURE__*/React.createElement("div", null);

var Avatar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Avatar, _PureComponent);

  var _super = _createSuper(Avatar);

  function Avatar() {
    var _this;

    _classCallCheck(this, Avatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.loader = new Image();
    _this.state = {
      error: false
    };

    _this.onImageError = function () {
      _this.setState({
        error: true
      });
    };

    return _this;
  }

  _createClass(Avatar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.src !== this.props.src) this.loadImage();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.loader.removeEventListener('error', this.onImageError);
    }
  }, {
    key: "loadImage",
    value: function loadImage() {
      var _this$props = this.props,
          src = _this$props.src,
          fallbackSrc = _this$props.fallbackSrc;

      if (fallbackSrc) {
        this.setState({
          error: false
        });
        this.loader.addEventListener('error', this.onImageError);
        this.loader.src = src;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style,
          backgroundColor = _this$props2.backgroundColor,
          iconBackgroundColor = _this$props2.iconBackgroundColor,
          src = _this$props2.src,
          fallbackSrc = _this$props2.fallbackSrc,
          size = _this$props2.size,
          shape = _this$props2.shape,
          profileType = _this$props2.profileType,
          theme = _this$props2.theme,
          classes = _this$props2.classes,
          container = _this$props2.container,
          other = _objectWithoutProperties(_this$props2, ["className", "style", "backgroundColor", "iconBackgroundColor", "src", "fallbackSrc", "size", "shape", "profileType", "theme", "classes", "container"]);

      var ProfileIcon = profileType && profileIcons[profileType];

      var _chooseProfileSize = chooseProfileSize(size),
          _chooseProfileSize2 = _slicedToArray(_chooseProfileSize, 3),
          profileSize = _chooseProfileSize2[0],
          roundSize = _chooseProfileSize2[1],
          borderWidth = _chooseProfileSize2[2];

      var profileSizePx = profileSize + 'px';
      var imageUrl = this.state.error && fallbackSrc || src;
      var children = ProfileIcon && React.createElement("div", {
        className: classes.profile,
        style: {
          backgroundColor: iconBackgroundColor || theme.avatar.colors.iconBackground,
          boxShadow: "0 0 0 ".concat(borderWidth, "px ").concat(theme.avatar.colors.profileBorder),
          width: profileSizePx,
          height: profileSizePx
        }
      }, React.createElement(ProfileIcon, {
        size: roundSize
      }));
      return cloneElement(isValidElement(container) ? container : _ref, _extends({}, other, {
        style: _extends({}, style, {
          backgroundColor: backgroundColor,
          width: size,
          height: size,
          backgroundImage: "url(".concat(imageUrl, ")")
        }),
        className: classnames(classes.avatar, classes[shape], className)
      }), children);
    }
  }]);

  return Avatar;
}(PureComponent);

Avatar.defaultProps = {
  size: 45,
  shape: 'circle'
};
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * CSS-класс аватарки
   */
  className: PropTypes.string,

  /**
   * Inline-стили
   */
  style: PropTypes.object,

  /**
   * Цвет фона
   */
  backgroundColor: PropTypes.string,

  /**
   * Цвет фона иконки
   */
  iconBackgroundColor: PropTypes.string,

  /**
   * URL картинки
   */
  src: PropTypes.string.isRequired,

  /**
   * Фолбек URL картинки
   */
  fallbackSrc: PropTypes.string,

  /**
   * Размер аватарки
   */
  size: PropTypes.number,

  /**
   * Форма аватарки
   */
  shape: PropTypes.oneOf(['circle', 'square', 'rounded']),

  /**
   * Тип профиля для отображения иконки
   */
  profileType: PropTypes.oneOf(['apple', 'facebook', 'championat', 'google', 'instagram', 'livejournal', 'mailru', 'odnoklassniki', 'pgumosru', 'rambler', 'sberbank', 'twitter', 'vkontakte']),

  /**
   * Элемент, который содержит контент, например `<Link />` в случае с `react-router`, или `<a />` если необходима ссылка
   */
  container: PropTypes.element
} : {};
export default withStyles(styles, {
  name: 'Avatar'
})(Avatar);